import ExtendableError from './ExtendableError';
export default class ParseError extends ExtendableError {

}